ACC.forgottenpassword = {

    _autoload: [
        ['bindEmailChange', $('#forgottenPwdEmail').length !== 0],
        ['bindForgottenPwdSubmitForm', $('#forgottenPwdForm').length !== 0],
        'setFocusOnHeading',
    ],

    captchaIsPresent: $('[data-recaptcha-control="getForgottenPwdInvisibleRecaptcha"]').length,

    bindForgottenPwdSubmitForm() {
        const form = $('#forgottenPwdForm');
        form.submit(function () {
            if ($(this).valid()) {
                if (ACC.forgottenpassword.captchaIsPresent) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.execute();
                } else {
                    ACC.forgottenpassword.handleSubmit();
                }
            }
            return false;
        });
    },

    bindEmailChange() {
        $('#forgottenPwdEmail').on('change input', ACC.forgottenpassword.enableFormSubmit);
    },

    handleSubmit() {
        const form = $('#forgottenPwdForm');
        const submitBtn = $('.js-forgottenPwd-submit');
        const actionUrl = form.attr('action');
        const formData = form.serialize();
        const successRedirectUrl = form.data('success-redirect');
        const inputEmail = form.find('#forgottenPwdEmail');
        const spanMessageElement = $('.js-button-message');

        $.post({
            url: actionUrl,
            data: formData,
            beforeSend() {
                if (spanMessageElement.length) {
                    spanMessageElement.html(submitBtn.data('disabled-message'));
                }
                ACC.buttonhelper.disable(submitBtn).withSpinner();
            },
            success() {
                window.location = successRedirectUrl;
            },
            error(error) {
                if (spanMessageElement.length) {
                    spanMessageElement.html('');
                }
                ACC.buttonhelper.enable(submitBtn);
                submitBtn.prop('disabled', true);

                form.validate().showErrors({
                    email: error.responseJSON,
                });

                if (inputEmail.length) {
                    inputEmail.focus();
                    inputEmail.on('focusout', (e) => {
                        e.stopPropagation();
                    });
                }

                if (ACC.forgottenpassword.captchaIsPresent) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.reset();
                }
            },
        });
    },

    enableFormSubmit() {
        const form = $('#forgottenPwdForm');
        const submitBtn = $('.js-forgottenPwd-submit');
        submitBtn.prop('disabled', !form.valid());
    },

    setFocusOnHeading() {
        const heading = document.querySelector('.page-forgottenPassword .c-sectionHeader.usrPassRequest');

        if (heading) {
            heading.focus();
        }
    },
};

// eslint-disable-next-line no-unused-vars
const recaptchaforgottenPasswordSubmitCallback = function () {
    ACC.forgottenpassword.handleSubmit();
};
